module.exports = __webpack_public_path__ + "img/il.cde29dc5.png";